export default __webpack_public_path__ + "static/media/pullQuote2OrbM.91d59d3b.svg";